import React from 'react';

import cn from 'classnames';
import dayjs from 'dayjs';

import calendarIcon from 'assets/images/properties/calendar-event.svg';
import clockIcon from 'assets/images/properties/clock.svg';
import mapPointIcon from 'assets/images/properties/map-point.svg';
import { ReturnComponentType } from 'common';
import { DateFormat } from 'enums';
import { PropertyType } from 'state';
import { convertCoordinate } from 'utils';
import './PropertyInfoSection.scss';

type PropertyInfoSectionType = {
  property: PropertyType;
  className?: string;
};

export const PropertyInfoSection = ({
  property,
  className,
}: PropertyInfoSectionType): ReturnComponentType => {
  return (
    <div className={cn('PropertyInfoSection', className)}>
      <section className="PropertyInfoSection_Body">
        <div className="PropertyInfoSection_Body_Id">
          ID:<span>{property.externalId ?? '-'}</span>
        </div>
        <img
          src={calendarIcon}
          alt="calendar-icon"
          className="PropertyInfoSection_Body_Icon"
        />
        <div className="PropertyInfoSection_Body_Detail">
          {property.inspections?.length && property?.inspections[0]?.createdAt
            ? dayjs(property?.inspections[0]?.createdAt).format(DateFormat.GENERAL)
            : '-'}
        </div>
        <img src={clockIcon} alt="clock-icon" className="PropertyInfoSection_Body_Icon" />
        <div className="PropertyInfoSection_Body_Detail">{property.period}</div>
      </section>

      <section className="PropertyInfoSection_Footer">
        <img
          src={mapPointIcon}
          alt="map-point-icon"
          className="PropertyInfoSection_Footer_Icon"
        />

        <div className="PropertyInfoSection_Footer_Detail">
          {convertCoordinate(property.latitude, true)}
        </div>
        {'\u00A0'}
        <div className="PropertyInfoSection_Footer_Detail">
          {convertCoordinate(property.longitude, false)}
        </div>
      </section>
    </div>
  );
};
